export default function MapOverlay({ children, className }) {
  return (
    <div className={`map-overlay absolute xl:mr-3 flex items-start ${className}`}>
      {children}
    </div>
  );
}
